module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [(_vm.message.show) ? _c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "green darken-3",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()], 1), _vm._v(" "), (_vm.pwdWarning) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "#ffdce0",
      "type": "error",
      "icon": "warning"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#86181d"
    }
  }, [_vm._v("\n          The password you provided is weak and can be easily guessed. To increase your security, please\n          "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("update your password")]), _vm._v("as soon as possible.\n        ")], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('kobeOverview')) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('kobe-overview', {
    attrs: {
      "userRole": _vm.currentUserRole
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('servicesHealth')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Services Health")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.getServicesHealthData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subtitle-1 text-xs-right"
  }, [_vm._v("Latest Updates : " + _vm._s(_vm.currentTime))]), _vm._v(" "), _c('services-health-list', {
    attrs: {
      "serviceList": _vm.healthCheckData
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('xero')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Xero Dashboard")])], 1), _vm._v(" "), _c('v-card-text', [_c('connect-xero')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('influencerTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('influencer-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('csTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('content-strategist-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('saleTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('sale-person-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('clientTasks')) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('client-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('postsSummary')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('posts-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('campaignSummary')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('campaign-summary')], 1) : _vm._e()], 1), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6a0c61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 2221
// module chunks = 0